"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _protocol = _interopRequireDefault(require("../../../common/backbone/sync/protocol.default"));

var _sync = _interopRequireDefault(require("../../../common/backbone/sync/sync"));

var _prepareQueryParams = _interopRequireDefault(require("./prepareQueryParams"));

var _dataCollection = _interopRequireDefault(require("../../../common/backbone/dataCollection"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultOptions = {
  parse: true,
  validate: false
};
var DEFAULT_SYNC_ENGINE = 'pooling',
    CONNECT_METHOD_NAME = 'connect',
    SEND_METHOD_NAME = 'send';

function _default(method) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var proto = Object.getPrototypeOf(this),
      ctr = proto.constructor,
      engineId,
      queryParams,
      syncOptions,
      Engine,
      _options$data = options.data,
      data = _options$data === void 0 ? {} : _options$data;
  queryParams = _prepareQueryParams["default"].call(this, method, data);
  syncOptions = _objectSpread({}, defaultOptions, {}, options, {}, queryParams);

  if (!syncOptions.protocol) {
    // null - skip protocol parsing
    // TODO MOVE PROTOCOL TO QUERYPARAMS
    syncOptions.protocol = typeof ctr.protocol !== 'undefined' ? ctr.protocol : _protocol["default"];
  } // TODO MOVE SYNC_ID OUTSIDE MODEL CLASS


  engineId = syncOptions.syncId || this.syncId || ctr.syncId || DEFAULT_SYNC_ENGINE;
  this.syncEngines = this.syncEngines || {};

  if (method === CONNECT_METHOD_NAME) {
    // Engine is active
    if (this.syncEngines[engineId]) {
      if (this.syncEngines[engineId].isOpen()) {
        return this.syncEngines[engineId];
      } else {
        // Engine is initiated but closed
        return this.syncEngines[engineId].connect();
      }
    } else {
      // new connection
      Engine = _sync["default"].getEngine(engineId);

      if (Engine) {
        var _onMessage = syncOptions.onMessage,
            _onError = syncOptions.onError;
        this.syncEngines[engineId] = new Engine(_objectSpread({}, syncOptions, {
          onMessage: function onMessage(data) {
            if (_this instanceof _dataCollection["default"]) {
              // collection will be parsed any time when .set is called with 'read' parser
              if (method !== 'read' && syncOptions.parse === true && typeof _this.parse === 'function') {
                data = _this.parse(data, syncOptions, method);
              }
            } else {
              if (syncOptions.parse === true && typeof _this.parse === 'function') {
                data = _this.parse(data, syncOptions, method);
              }
            }

            if (typeof _this.syncResolve === 'function') {
              _this.syncResolve(data, syncOptions);
            }

            if (typeof _onMessage === 'function') {
              _onMessage(data);
            }
          },
          onError: function onError(error) {
            if (syncOptions.parse === true && typeof _this.parse === 'function') {
              error = _this.parse(error, syncOptions, 'error');
            }

            if (typeof _onError === 'function') {
              _onError(error);
            }
          }
        })).connect();
        return this.syncEngines[engineId];
      } else {
        if (process && process.env.NODE_ENV !== 'production') {
          console.warn("Sync. Engine ".concat(engineId, " not found."));
        }

        return Promise.reject("Sync. Engine ".concat(engineId, " not found."));
      }
    } // send message

  } else if (method === SEND_METHOD_NAME) {
    if (this.syncEngines[engineId] && this.syncEngines[engineId].isOpen()) {
      return this.syncEngines[engineId].send(syncOptions.data, syncOptions);
    } else {
      if (process && process.env.NODE_ENV !== 'production') {
        console.warn("Sync. Cannon send data to closed stream.");
      }

      return Promise.reject("Sync. Cannon send data to closed stream.");
    }
  } else {
    if (process && process.env.NODE_ENV !== 'production') {
      console.warn("Sync. Unresolved stream method ".concat(method, "."));
    }

    return Promise.reject("Sync. Unresolved stream method ".concat(method, "."));
  }
}